import type { FilterState } from "../../../pages/fsrs/AnalyticsDashboardPage";

interface OverviewTabProps {
  filters: FilterState;
}

export function OverviewTab({ filters: _filters }: OverviewTabProps) {
  return (
    <div className="space-y-6">
      <h2 className="h4">Overview</h2>
      <p className="text-gray-600">
        Existing charts will be moved here (Retention Rate, Difficulty Distribution, Card State
        Breakdown, etc.)
      </p>
    </div>
  );
}
